import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"line-chart-3, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconLineChart3"><path d="M20.9961 20H21.9961V4H20.9961V20Z" fill="currentColor"/><path d="M15.6641 8V20H14.6641V8H15.6641Z" fill="currentColor"/><path d="M8.33203 20H9.33203L9.33203 12H8.33203L8.33203 20Z" fill="currentColor"/><path d="M3 20V16H2V20H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLineChart3;
